import React from 'react';
import './paymentSection.scss';

type Props = {
    isAuthenticated: boolean;
    payWithSBP: boolean;
    setPayWithSBP: (v: boolean) => void;
    payWithInstallments: boolean;
    setPayWithInstallments: (v: boolean) => void;
};

export const PaymentSection: React.FC<Props> = ({ isAuthenticated, payWithSBP, setPayWithSBP, payWithInstallments, setPayWithInstallments }) => {
    return (
        <section className="paymentSection" aria-label="Оплата">
            <header className="paymentSection__head">
                <h2 className="paymentSection__title">Оплата</h2>
            </header>

            <div className="paymentSection__options" role="radiogroup" aria-label="Способ оплаты">
                <label className={`paymentSection__option ${!payWithSBP && !payWithInstallments ? 'paymentSection__option--active' : ''}`}>
                    <div className="paymentSection__option_wrapper">
                        <img
                            className="paymentSection__option_img"
                            src={!payWithSBP && !payWithInstallments ? '/cart/card_active.png' : '/cart/card.png'}
                            alt=""
                            aria-hidden="true"
                        />
                        <span className="paymentSection__text">Оплата картой</span>
                    </div>
                    <input
                        type="radio"
                        name="paymethod"
                        checked={!payWithSBP && !payWithInstallments}
                        onChange={() => {
                            setPayWithInstallments(false);
                            setPayWithSBP(false);
                        }}
                        disabled={!isAuthenticated}
                    />
                    <span className="paymentSection__mark" aria-hidden="true" />
                </label>

                <label className={`paymentSection__option ${payWithSBP ? 'paymentSection__option--active' : ''}`}>
                    <div className="paymentSection__option_wrapper">
                        <img className="paymentSection__option_img" src={payWithSBP ? '/cart/sbp_active.png' : '/cart/sbp.png'} alt="" aria-hidden="true" />
                        <span className="paymentSection__text">СБП</span>
                    </div>
                    <input
                        type="radio"
                        name="paymethod"
                        checked={payWithSBP}
                        onChange={() => {
                            setPayWithInstallments(false);
                            setPayWithSBP(true);
                        }}
                        disabled={!isAuthenticated}
                    />
                    <span className="paymentSection__mark" aria-hidden="true" />
                </label>

                <label className={`paymentSection__option ${payWithInstallments ? 'paymentSection__option--active' : ''}`}>
                    <div className="paymentSection__option_wrapper">
                        <img
                            className="paymentSection__option_img"
                            src={payWithInstallments ? '/cart/dolyami_active.png' : '/cart/dolyami.png'}
                            alt=""
                            aria-hidden="true"
                        />
                        <span className="paymentSection__text">Частями</span>
                    </div>
                    <input
                        type="radio"
                        name="paymethod"
                        checked={payWithInstallments}
                        onChange={() => {
                            setPayWithSBP(false);
                            setPayWithInstallments(true);
                        }}
                        disabled={!isAuthenticated}
                    />
                    <span className="paymentSection__mark" aria-hidden="true" />
                </label>
            </div>

            {!isAuthenticated ? <div className="paymentSection__note">Оплата станет доступна после подтверждения номера в блоке «Получатель».</div> : null}
            {/* {payWithInstallments && isAuthenticated ? (
                <div className="paymentSection__note">Для «Плати частями» будет использован подтверждённый номер телефона из блока «Получатель».</div>
            ) : null} */}
        </section>
    );
};
